module.exports = __webpack_public_path__ + "img/materials_cn.675b3bd.jpg";